/**
 * 工作环境常量变量初始化, 在所有页面代码之前调用
 * */
import { getEnv } from './environmentParams';

const changeFavicon = (link: string) => {
  if (!link) return;

  let favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;

  if (favicon) {
    favicon.href = link;
  } else {
    favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.href = link;
    document.head.appendChild(favicon);
  }
};

function wrapState(action: string) {
  const raw = history[action];
  return function (this: any) {
    const wrapper = raw.apply(this, arguments);

    const e = new Event(action);

    _.set(e, 'stateInfo', arguments);

    window.dispatchEvent(e);

    return wrapper;
  };
}
// 修改原始定义
history.pushState = wrapState('pushState');
history.replaceState = wrapState('replaceState');

// 在 JSRuntime 或者 Utils 之前执行，所以不要使用 JSRuntime 和 Utils 中的方法

function getCustomDomain(url: URL, currentUrl: URL): string {
  const { host } = window.location;
  const { host: urlHost, protocol: urlProtocol, pathname } = url;
  if (!_.isString(urlHost)) return '';
  const companyIdentity = _.replace(host, currentUrl.host, '') || '';
  return `${urlProtocol}//${companyIdentity}${urlHost}${pathname}`;
}

function resetOneIDEnv(options: { siteName: string }) {
  getEnv();

  // NOTICE: 浏览器 tab logo 变更
  changeFavicon(`${_.trimEnd(window.ONEID_PUBLIC_CDN_URL, '/')}/images/logo/favicon.ico`);

  const { host, hostname } = window.location;
  const { siteName } = options;

  let siteURL;
  switch (siteName) {
    case 'IDP':
      siteURL = new URL(window.ONEID_PUBLIC_IDP_SITE);
      break;
    case 'PORTAL':
      siteURL = new URL(window.ONEID_PUBLIC_PORTAL_SITE);
      break;
    default:
      siteURL = new URL(window.ONEID_PUBLIC_ADMIN_SITE);
      break;
  }

  if (!siteURL?.href) return; // 流程上不应该有这种情况

  const isPrivate = RUNTIME_LOCAL_ENV === 'private';

  window.ONEID_PUBLIC_ORIGINAL_IDP_SITE = window.ONEID_PUBLIC_IDP_SITE;
  window.ONEID_PUBLIC_ORIGINAL_PORTAL_SITE = window.ONEID_PUBLIC_PORTAL_SITE;
  window.ONEID_PUBLIC_ORIGINAL_ADMIN_SITE = window.ONEID_PUBLIC_ADMIN_SITE;

  window.ONEID_PUBLIC_OAUTH2_URL = isPrivate
    ? `${_.trimEnd(window.ONEID_PUBLIC_GATEWAY_URL, '/')}/oauth2`
    : _.replace(window.ONEID_PUBLIC_GATEWAY_URL, 'api', 'oauth2');

  window.ONEID_ACCOUNT_GATEWAY_URL =
    window.ONEID_ACCOUNT_GATEWAY_URL || window.ONEID_PUBLIC_GATEWAY_URL;
  window.ONEID_ACCOUNT_OAUTH2_URL = isPrivate
    ? `${_.trimEnd(window.ONEID_ACCOUNT_GATEWAY_URL, '/')}/oauth2`
    : _.replace(window.ONEID_ACCOUNT_GATEWAY_URL, 'api', 'oauth2');

  // 针对SaaS做处理
  const isDefaultSaaSDomain = _.endsWith(hostname, siteURL.hostname) && !isPrivate; // NOTICE 避免之后私有化域名与我们saas域名相同

  if (isPrivate) {
    window.ONEID_PUBLIC_ORIGIN = false;
    window.ONEID_PUBLIC_ACCOUNT_DOMAIN = false;
    window.ONEID_PUBLIC_CUSTOM_DOMAIN = true;
  } else {
    window.ONEID_PUBLIC_ORIGIN = host === siteURL.host;
    window.ONEID_PUBLIC_ACCOUNT_DOMAIN = !window.ONEID_PUBLIC_ORIGIN && isDefaultSaaSDomain;
    window.ONEID_PUBLIC_CUSTOM_DOMAIN = !window.ONEID_PUBLIC_ORIGIN && !isDefaultSaaSDomain;
  }

  // 由企业标识组合成的SaaS域名
  if (window.ONEID_PUBLIC_ACCOUNT_DOMAIN) {
    window.ONEID_PUBLIC_IDP_SITE = getCustomDomain(new URL(window.ONEID_PUBLIC_IDP_SITE), siteURL);
    window.ONEID_PUBLIC_PORTAL_SITE = getCustomDomain(
      new URL(window.ONEID_PUBLIC_PORTAL_SITE),
      siteURL,
    );
    window.ONEID_PUBLIC_ADMIN_SITE = getCustomDomain(
      new URL(window.ONEID_PUBLIC_ADMIN_SITE),
      siteURL,
    );
  }
}

resetOneIDEnv({
  siteName: _.upperCase(RUNTIME_APP_NAME),
});
